export const pie_alarms_category = {
  widgetType: 'chart',
  chartType: 'pie',
  title: 'Alarms by Category',
  valueKey: 'alarmDuration',
  groupKey: 'alarmCategory',
  dataType: 'groupTotals'
}

export const pie_alarms_type = {
  widgetType: 'chart',
  chartType: 'pie',
  title: 'Alarms by Type',
  valueKey: 'alarmDuration',
  groupKey: 'alarmType',
  dataType: 'groupTotals'
}

export const bar_alarms_by_alarm_category_runlog_id = {
  chartType: 'bar',
  widgetType: 'chart',
  title: 'Alarms by Recipe',
  valueKey: 'alarmDuration',
  groupKey: 'recipeDescription',
  categoryKey: 'runlogId',
  scaleType: 'band',
  dataType: 'categoryTotals',
}

export const charts = { pie_alarms_category, pie_alarms_type, bar_alarms_by_alarm_category_runlog_id }